@if (showLoadMoreButton || dataLoading) {
  <div class="load-more-wrapper">
    <div class="load-more-but">
      <button id="load-more-button" data-cy="load-more-button" mat-flat-button class="mat-primary btn btn-add" (click)="onLoadMore()" [disabled]="dataLoading">
        Load more
        @if (dataLoading) {
          <mat-spinner class="small-loader" diameter="20" strokeWidth="2"> </mat-spinner>
        }
      </button>
    </div>
  </div>
}
